import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {SearchBar as Search} from 'shells/search-bar/search-bar';

import './template-sidebar';

type Props = {
    value: string;
    onChange: (val: string) => void;
};

export function SearchBar(props: Props) {
    return (
        <StackLegacy spacing={4}>
            <Search {...props} placeholder='Search templates…' />
        </StackLegacy>
    );
}
